import { API, API_POST } from "../../Config";

export const handleAddAboutUs = (payload) => {
  const f = new FormData();

  f.append("id", 1);
  f.append("about_us", payload.policy);

  return API_POST(API.addpolicy, f);
};
